{
  "click-to-reveal": { "className": "th-click-to-reveal" },
  "flash-cards": { "className": "th-flash-cards" },
  "thc-flash-cards": { "className": "th-flash-cards" }
}
